import { render, staticRenderFns } from "./WorkIconSearch.vue?vue&type=template&id=1116a70a"
import script from "./WorkIconSearch.vue?vue&type=script&lang=js"
export * from "./WorkIconSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports